import React from 'react'
import {
    OverContainerSection,
    Section,
    SectionInformationData,
    SectionForm,
    SectionData,
    TypographySection,
    Content,
    TypographyContent,
} from './styles'
import { IVacancyFields } from 'src/types/contenfull'
import { SectionFormContent } from './sectionFormContent'
import { useTranslations, useI18nInstance } from 'src/provider/LocaleProvider'

interface Props {
    were: IVacancyFields
}

export const SectionInformation = ({ were }: Props) => {
    const t = useTranslations()
    const i18n = useI18nInstance()

    return (
        <OverContainerSection>
            <Section
                paddingTop={['large', 'large', 'xsixty', 'xsixty']}
                marginBottom={['medium', 'medium', 'large', 'titlle']}
            >
                <SectionInformationData
                    marginBottom={['xxmedium', 'xxmedium', 0, 0]}
                >
                    <SectionData>
                        <TypographySection
                            variant={'h1'}
                            fontSize={[
                                'xxxmedium',
                                'xxxmedium',
                                'large',
                                'xlarge',
                            ]}
                            fontWeight={700}
                        >
                            {t('worldWile.vacant.what')}
                        </TypographySection>
                        <Content>
                            <TypographyContent
                                variant={'h1'}
                                fontSize={[
                                    'xxxsmall',
                                    'xxxsmall',
                                    'medium',
                                    'medium',
                                ]}
                                fontWeight={500}
                            >
                                {i18n.language === 'es'
                                    ? were.whatWereLookingForSpanish
                                    : were.whatWereLookingFor}
                            </TypographyContent>
                        </Content>
                    </SectionData>
                    <SectionData marginTop={'xxmedium'}>
                        <TypographySection
                            variant={'h1'}
                            fontSize={[
                                'xxxmedium',
                                'xxxmedium',
                                'large',
                                'xlarge',
                            ]}
                            fontWeight={700}
                        >
                            {t('worldWile.vacant.qualifications')}
                        </TypographySection>
                        <Content>
                            <TypographyContent
                                variant={'h1'}
                                fontSize={[
                                    'xxxsmall',
                                    'xxxsmall',
                                    'medium',
                                    'medium',
                                ]}
                                fontWeight={500}
                            >
                                {i18n.language === 'es'
                                    ? were.qualificationsSpanish
                                    : were.qualifications}
                            </TypographyContent>
                        </Content>
                    </SectionData>
                    <SectionData marginTop={'xxmedium'}>
                        <TypographySection
                            variant={'h1'}
                            fontSize={[
                                'xxxmedium',
                                'xxxmedium',
                                'large',
                                'xlarge',
                            ]}
                            fontWeight={700}
                        >
                            {t('worldWile.vacant.perks')}
                        </TypographySection>
                        <Content>
                            <TypographyContent
                                variant={'h1'}
                                fontSize={[
                                    'xxxsmall',
                                    'xxxsmall',
                                    'medium',
                                    'medium',
                                ]}
                                fontWeight={500}
                            >
                                {i18n.language === 'es'
                                    ? were.perksBenefitsSpanish
                                    : were.perksBenefits}
                            </TypographyContent>
                        </Content>
                    </SectionData>
                </SectionInformationData>
                <SectionForm paddingTop={'xxxsmall'} paddingBottom={'xxxsmall'}>
                    <SectionFormContent />
                </SectionForm>
            </Section>
        </OverContainerSection>
    )
}
